import Svg, { Path } from "react-native-svg";

/**
 * A `+`, for a stepper's increase control and for the catalog card's ADD button.
 *
 * `MinusIcon`'s twin, and fixed the same way — see that file for the full account. In short:
 * the export was an `<svg>` at a module's top level rather than a component, `#634090` was one
 * merchant's colour baked into the fill (so `color` is required here), and the Material `<mask>`
 * clipped the drawing to a rect covering the whole canvas, which removed nothing while carrying
 * a document-wide `id` into every instance.
 *
 * ⚠️ The viewBox is the INK — `5 5 14 14` — so `size` means the width of the cross, exactly as
 * it did for the `PlusGlyph` this replaces, and no caller has to change its number. The cross
 * spans x 5→19 and y 5→19 of the 24-unit canvas, so that crop fits it on both axes.
 */
export function AddIcon({ color, size = 14 }: { color: string; size?: number }) {
  return (
    <Svg width={size} height={size} viewBox="5 5 14 14" fill="none">
      <Path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" fill={color} />
    </Svg>
  );
}
AddIcon.displayName = "AddIcon";
export default AddIcon;
